module.exports = __webpack_public_path__ + "static/media/wavm8s-022-dj-mare.9d94896.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-022-dj-mare.mp3
// module id = tSzY
// module chunks = 0